
import React, {Component} from "react";
import {bindActionCreators} from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import {fetchBrandProfile, fetchBrandVideos, fetchBrandEvents } from "store/posts/actions";
import NProgress from "components/NProgress";
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Axios from "/plugins/axios";
import Hidden from '@material-ui/core/Hidden';
import {   
    BrowserView,
    MobileView,
    isBrowser,
    isMobile } from "react-device-detect";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Link } from "routes";
// import TagManager from 'react-gtm-module'
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import BrandTabs from '/components/Brand/BrandTabs';
import MobileNewsItem from "/components/Mobile/MobileNewsItem";
import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
import MobileFeatureCarouselItem from '/components/Mobile/MobileFeatureCarouselItem';
import MobileFeatureCarousel from '/components/Mobile/MobileFeatureCarousel';
import DesktopFeatureCarousel from '/components/Desktop/DesktopFeatureCarousel';
import DesktopFeatureCarouselItem from '/components/Desktop/DesktopFeatureCarouselItem';
import AboutToggle from '/components/Brand/AboutToggle';
import SeoMeta from '/components/seoMeta';
import CustomImage from '/components/customImage';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    // root: {
    //     flexGrow: 1,
    //     // display: 'flex',
    //     flexWrap: 'wrap',
    //     justifyContent: 'space-around',
    //     overflow: 'hidden',
    //     backgroundColor: theme.palette.background.paper,
    //     // padding: '20px 0px'
    // },
    root: {
        // display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
    },

    coverImg: {
        height: 250,
        width: '100%',
        borderBottom: '1px solid #efefef',
        objectFit: 'cover',
        [theme.breakpoints.up('md')]: {
            height: 370
        },
    },
    floatLogoContainer: {
        position: 'absolute',
        width: 150,
        height: 150,
        bottom: '-30%',
        marginLeft: 'auto',
        marginRight: 'auto',
        left: 0,
        right: 0,
        backgroundColor: '#fff', // #f7f7f7
        borderRadius: '50%', 
        border: '4px solid #fefefe',
        boxSizing: 'initial',
        boxShadow: '0px 0px 0px 4px #fff inset',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
          bottom: '-21%',

        },
    },
    floatLogo: {
        width: 150,
        height: 150,
        // padding: 25
        // borderRadius: '50%',
        // border: '4px solid #fff'
    },
    layout: {
        marginLeft: 'auto',
        marginRight: 'auto',
          [theme.breakpoints.up('md')]: {
            width: 1140,
            maxWidth: 1140,
          },
          [theme.breakpoints.only('md')]: {
            width: '100%',
          },
          [theme.breakpoints.only('sm')]: {
            width: 650
          },
    },
    
    profileAbout: {
        textAlign: 'center',
    },
    aboutDescription: {
        padding: '25px 0px 0px',
        textAlign: 'center'
    },
    titleDivider: {
    backgroundColor: '#e8e3de',
    boxShadow: '0px -2px 0px #b0b0b0',
    height: 3,
    margin: '0 auto',
    width: '15%',
    [theme.breakpoints.down('sm')]: {
        
        width: '27%',
    },
    },
    fontIcon: {
        fontSize: 17,
        color: '#014ca9'
    },
    iconBorder: {
        display: 'inline-block',
        boxShadow: '0px 0px 2px #000',
        borderRadius: '50%',
        width: 30,
        height: 30,
        lineHeight: '34px',
        margin: '0px 7px'
    },
    button: {
        margin: '13px 0px 23px',
        paddingLeft: 25,
        letterSpacing: '1px'
    },

    brandBadgeWrapper:{
        position: 'absolute',
        right: 12,
        top: -6,
        textAlign: 'center',
        zIndex: 1,
      },
      brandBadge: {
        background: '#fff',
        color: '#ff9803',
        borderRadius: '0px 0px 7px 7px',
        border: '1px solid #e9e9e9',
        minHeight: '28px',
        width: 68,
        display: 'inline-block',
        overflow: 'hidden'
      },
      findJobButton: {
        position: 'fixed',
        bottom: 0,
        width: '100%',
        background: 'red', zIndex: 2,     borderRadius: 0,
        color: '#fff',
        padding: '10px 0px',
        textTransform: 'initial',
        fontSize: 18,
        '&:hover': {
            background: "red",
         },
        [theme.breakpoints.up('md')]: {
            width: 1140,
            margin: '0 auto',
            left: 0,
            right: 0,
            bottom: 0,
        }
      }
});

const getNewCount = count => count+1
  class BrandProfileDetail extends Component {
    constructor(props){
        super(props);
        this.state = {
            newsItems: [],
            videoItems: [],
            eventItems: [],
            nextEvents: this.props.brandEventsLink.next,
            isLoading: true,
            next: this.props.links.next,
            nextVideos: this.props.brandVideosLink.next,
            url: this.props.url,
            count: 1,
        }
    }

    static async getInitialProps({store, query, asPath, isServer, res}) {
        const { brandProfile } = query;
        const currentDateTime = new Date().toISOString();
        await store.execSagaTasks(isServer, dispatch => {
          dispatch(fetchBrandProfile(brandProfile, currentDateTime));
        //   return { brandProfile, asPath, isServer, currentDateTime};   
        });
        await store.execSagaTasks(isServer, dispatch => {
            store.dispatch(fetchBrandVideos(brandProfile, currentDateTime));
            store.dispatch(fetchBrandEvents(brandProfile, currentDateTime, 6));
           
          });
        if(!store.getState().posts.brandProfile) {
          console.log("store.getState().posts")
          console.log(store.getState().posts);
          res.statusCode = store.getState().posts.error.status || 404;
        }
        return { brandProfile, asPath, isServer, currentDateTime};   
    }
    nextVideoPage = (url) => {
        // const nextPerPage = isMobile ? 6 : 4
        url = `/brands/${this.props.url.query.brandProfile}/videos?perPage=8&published_date=${this.props.currentDateTime}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        this.setState({ 
            loading: true
         });
        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.videoItems.push(value))
            
                this.setState({
                    isLoading: false,
                    videoItems: this.state.videoItems,
                    nextVideos: res.data.links.next,
                    loading: false,
                })
            })
    }
    __nextVideoBtn () {
        const {classes, uniReadable} = this.props;
        if(this.state.next != null) {
            return (
              <div style={{textAlign: 'center'}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => !this.state.loading ? this.nextVideoPage(this.state.nextVideos) : null}
                >
                    <span>
                        {
                            uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                        }
                    </span>
                  {this.state.loading ? 
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        : 
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div> 
                     }
                </Button>
                
              </div>
            )
        }
    }
    
    nextPage = (url) => {
        const nextPerPage = isMobile ? 6 : 8
        url = `/brands/${this.props.url.query.brandProfile}?published_date=${this.props.currentDateTime}&perPage=${nextPerPage}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        this.setState({ 
            loading: true
         });
        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.newsItems.push(value))
                this.setState({
                    isLoading: false,
                    newsItems: this.state.newsItems,
                    next: res.data.links.next,
                    loading: false,
                })
            })
    }
     __nextBtn () {
        const {classes, uniReadable} = this.props;
        if(this.state.next != null) {
            return (
              <div style={{textAlign: 'center'}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
                >
                    <span>
                        {
                            uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                        }
                    </span>
                  {this.state.loading ? 
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        : 
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div> 
                     }
                </Button>
                
              </div>
            )
        }
    }
    nextEventPage = (url) => {
        // const nextPerPage = isMobile ? 6 : 4
        url = `/brands/${this.props.url.query.brandProfile}/events?perPage=6&published_date=${this.props.currentDateTime}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        this.setState({ 
            loading: true
         });
        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.eventItems.push(value))
            
                this.setState({
                    isLoading: false,
                    eventItems: this.state.eventItems,
                    nextEvents: res.data.links.next,
                    loading: false,
                })
            })
    }
    __nextEventBtn () {
        const {classes, uniReadable} = this.props;
        if(this.state.next != null) {
            return (
              <div style={{textAlign: 'center'}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => !this.state.loading ? this.nextEventPage(this.state.nextEvents) : null}
                >
                    <span>
                        {
                            uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                        }
                    </span>
                  {this.state.loading ? 
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        : 
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div> 
                     }
                </Button>
                
              </div>
            )
        }
    }

    render() {
        const {classes, brandProfile, brandArticles, isServer, links, brandVideos, brandEvents} = this.props;
        let { newsItems, videoItems, eventItems } = this.state;
        let brandProfileLinks = brandProfile.links ? brandProfile.links : null;
        let galleryItems = brandProfile.gallery ? brandProfile.gallery : null;
        let carouselMobile = brandArticles.slice(0, 3)
        let carouselDesktop =  brandArticles.slice(0, 4)
        let carousel = isMobile ? carouselMobile : carouselDesktop
        /*
        let brandArticlesMobile = brandArticles.filter((v, i)=>{
            return i > 2
         })
         let brandArticlesDesktop = brandArticles.filter((v, i)=>{
            return i > 3
         })
        const brandArticlesItems = isMobile ? brandArticlesMobile : brandArticlesDesktop // without index for carousel(remaining index for brand articles)
        */
        const catIndex = -1;
        let nextPageItemsMobile = newsItems && newsItems.map((newsItem, index) => (
          <React.Fragment key={index}>
            <MobileNewsItem key={index} item={newsItem} />
          </React.Fragment>
            ))
        let nextPageItemsDesktop =  <Grid container style={{marginBottom: 15}}>
        {newsItems && newsItems.map((item, index) => (
            <React.Fragment key={index}>
            <Grid item xs={3}>
                <DesktopNewsItem item={item}  />
            </Grid>
            </React.Fragment>
                    ))}  
        </Grid>
  
        return (
            <div>
                <Head>
                    <title>{brandProfile.slug}</title>
                </Head>
                <SeoMeta 
                        url={`${process.env.BACKEND_URL}${this.props.asPath}`} 
                        type="profile"
                        title={fontUniOrConvertZawgyi(brandProfile.name)}
                        description={fontUniOrConvertZawgyi(brandProfile.description)}
                        image={brandProfile.logo} 
                        section={brandProfile.name}
                        keywords={brandProfile.name}
                    />                
                <NProgress/>
                <div className={classes.root}>
                {
                    brandProfile.cta !== null ?
                    <Button variant="contained" id="ctaButton" ref={this.props.ctaButtonRef} className={classes.findJobButton} href={brandProfile.cta} target="_blank" >
                        Find a Job
                    </Button>
                    : null
                }
                   
                    {brandProfile && (
                        <div className={classes.layout} style={{ marginLeft: 'auto',
                        marginRight: 'auto'}}>
                            <div style={{position: 'relative', background: '#fff'}}>
                                {
                              brandProfile.cover.teaser ?
                                        <a href={brandProfile.website} target="_blank"> 
                                            <CustomImage 
                                                imgSrc={brandProfile.cover.teaser}
                                                imgClass={classes.coverImg} 
                                                customStyle={`cursor: pointer;`} 
                                            />
                                        </a>
                                    :
                                        <a href={brandProfile.website} target="_blank">
                                            <CustomImage 
                                                imgSrc="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png"
                                                imgClass={classes.coverImg} 
                                                customStyle={`cursor: pointer;`} 
                                            />
                                        </a>
                                }
                                
                                <span className={classes.floatLogoContainer}>
                                    <a href={brandProfile.website} target="_blank"> 
                                        <CustomImage 
                                            imgSrc={brandProfile.logo}
                                            imgClass={classes.floatLogo} 
                                        />
                                    </a>                                
                                </span>
                            </div>
                           
                          {/* ************** About Us ****************** */}
                            <Card raised style={{padding: '65px 0px 5px'}}>
                                <CardContent>
                                    <Grid container spacing={16} direction="row" justify="center" alignItems="center">  
                                        <Grid item xs={12} sm={8} md={10} className={classes.profileAbout} style={{ paddingTop: 20 }}>
                                        {
                                            brandProfile.facebook ?  
                                            <a className={classes.iconBorder} href={brandProfile.facebook} target="_blank">
                                                <FontAwesomeIcon className={classes.fontIcon} icon={['fab', 'facebook-f']} />
                                            </a>
                                            : null
                                        }
                                        {
                                            brandProfileLinks !== undefined && brandProfileLinks !== null ? brandProfileLinks.map((brandProfileLink, index) => {
                                                return(
                                                    <a className={classes.iconBorder} href={brandProfileLink.link} key={index} target="_blank">
                                                    {
                                                    brandProfileLink.icon != "globe" ?
                                                    <FontAwesomeIcon icon={['fab', `${brandProfileLink.icon}`]} style={{color: `${brandProfileLink.color}`}} /> 
                                                    :
                                                    <FontAwesomeIcon icon={faGlobe} style={{color: `${brandProfileLink.color}`}} />
                                                    }
                                                    </a>
                                                )
                                            }) : null
                                        }
                                        </Grid>
                                    </Grid>  
                                        
                                 <AboutToggle brandProfile={brandProfile} />
                                </CardContent>
                            </Card>
                           {/* **************** Brand Tabs **************** */}
                            <BrandTabs 
                                brandProfileName={brandProfile.name} 
                                brandProfileSlug={brandProfile.slug} 
                                gallery={galleryItems} 
                                // articles={brandArticlesItems} 
                                articles={brandArticles}
                                carouselItems={carousel} 
                                func={this.__nextBtn()}
                                videoNextFunc={this.state.nextVideos ? this.__nextVideoBtn() : null}
                                eventNextFunc={this.state.nextEvents ? this.__nextEventBtn() : null}
                                itemsMobile={nextPageItemsMobile} 
                                itemsDesktop={nextPageItemsDesktop}
                                brandVideos={brandVideos ? brandVideos : null}
                                brandEvents={brandEvents ? brandEvents : null}
                                newsItems={newsItems}
                                videoItems={videoItems}
                                eventItems={eventItems}
                                mobileMaxNum='6'
                            />

                        </div>
                    )}
                </div>
            </div>
        );
    }
    componentDidMount() {
        const {isServer} = this.props;
        window.noGlobalAds = true;
        this.setState({ next: this.props.links.next });
    }
      
    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}

BrandProfileDetail.propTypes = {
    classes: PropTypes.object.isRequired,
    brandProfile: PropTypes.object.isRequired,
    brandArticles: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
    brandProfile: state.posts.brandProfile.profile,
    brandArticles: state.posts.brandProfile.data,
    links: state.posts.brandProfile.links,
    brandVideos: state.posts.brandVideos.data,
    brandVideosLink: state.posts.brandVideos.links,
    brandEvents: state.posts.brandEvents.data,
    brandEventsLink: state.posts.brandEvents.links,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchBrandProfile,
    fetchBrandVideos,
    fetchBrandEvents,
}, dispatch);

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(withReduxSaga(withStyles(styles)(BrandProfileDetail)));
